/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../../core/models/Node';
import { License } from '../../core/models/common/License';
import { Document } from '../../core/models/Document';

/**
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {Node} parent
 * @class
 * @extends License
 */
export abstract class AaiLicense extends License {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super();
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
AaiLicense["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiLicense";
AaiLicense["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




